import { ReactNode } from 'react';

import { Badge, Tooltip } from '@mui/material';

import { AppButton, AppButtonCollapsedContext } from '@/shared/ui/AppButton';

import { ButtonGroup, getToolbarAppButtonSx } from './GeneratikTableToolbar.styles';
import { ToolbarPrimaryButton } from './GeneratikTableToolbar.types';

interface ToolbarRightSectionProps {
  buttons: ToolbarPrimaryButton[] | ReactNode;
  collapsed?: boolean;
}

const ToolbarRightSection = ({ buttons, collapsed = false }: ToolbarRightSectionProps) => {
  if (!Array.isArray(buttons)) {
    return (
      <AppButtonCollapsedContext.Provider value={collapsed}>
        {buttons}
      </AppButtonCollapsedContext.Provider>
    );
  }

  if (buttons.length === 0) return null;

  return (
    <ButtonGroup>
      {buttons.map((button) => (
        <Tooltip
          key={button.id}
          title={collapsed ? button.label : (button.tooltip ?? '')}
          arrow
          disableHoverListener={!collapsed && !button.tooltip}
        >
          <span>
            <Badge
              badgeContent={button.badge}
              color="error"
              variant="dot"
              invisible={!button.badge}
            >
              <AppButton
                variant="primary"
                size="small"
                collapsed={collapsed}
                startIcon={button.icon}
                onClick={button.onClick}
                disabled={button.disabled}
                data-testid={button.dataTestId}
                sx={getToolbarAppButtonSx(collapsed)}
              >
                {button.label}
              </AppButton>
            </Badge>
          </span>
        </Tooltip>
      ))}
    </ButtonGroup>
  );
};

export default ToolbarRightSection;
